import React, { useMemo } from "react";
import PropTypes from "prop-types";

import { noop } from "utils/common";
import { API_URL, ASSET_TYPES } from "utils/constants";
import { useTooltipRebuild } from "hooks/useTooltipRebuild";

import "./AssetThumbnail.css";

export default function AssetThumbnail(props) {
	const { assetType, libraryId, details = {}, onLoad = noop } = props;
	const { name = "" } = details;

	useTooltipRebuild(details);

	// todo: Use <AssetPreview /> from Rhombus
	const thumbnail = useMemo(() => {
		if (libraryId) {
			let src;
			if (assetType === ASSET_TYPES.IMAGE && name) {
				if (details.formData) {
					const file = details.formData.get("files");
					src = URL.createObjectURL(file);
				} else {
					src = `${API_URL}/crm/v1/creative-libraries/${libraryId}/images/show/${name}`;
				}

				return <img src={src} alt={name} onLoad={onLoad} onError={onLoad} />;
			} else if (assetType === ASSET_TYPES.VIDEO) {
				return (
					<div className="video-no-thumb">
						<i className="fas fa-video" />
						<i className="fas fa-check" />
					</div>
				);
			}
		}

		return null;
	}, [libraryId, details, assetType]);

	return (
		<div className="asset-thumbnail">
			{thumbnail}
		</div>
	);
}

AssetThumbnail.displayName = "AssetThumbnail";

AssetThumbnail.propTypes = {
	assetType: PropTypes.oneOf([ASSET_TYPES.IMAGE, ASSET_TYPES.VIDEO]),
	libraryId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
	onLoad: PropTypes.func,
	details: PropTypes.object,
};

AssetThumbnail.defaultProps = {
	onLoad: noop,
};
